export default __webpack_public_path__ + "static/media/check-icon-yellow.0bef4eb5.svg";